import React, { useContext } from "react";
import { VendorContext } from "../../../../context/vendor/VendorContext";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import Step6 from "./step6";

const NaturalPerson = () => {
  const { activeStep } = useContext(VendorContext);

  return (
    <>
      {activeStep === 1 && <Step1 />}
      {activeStep === 2 && <Step2 />}
      {activeStep === 3 && <Step3 />}
      {activeStep === 4 && <Step4 />}
      {activeStep === 5 && <Step5 />}
      {activeStep === 6 && <Step6 />}
    </>
  );
};

export default NaturalPerson;
